<!--
 * @Author: LXG
 * @Date: 2021-05-12
 * @Editors: LXG
 * @LastEditTime: 2021-07-16 16:00:35
 * @Description: layout - header
-->
<template>
  <div>
    <div class="idx_wrapper" id="fixedMenuCont">
      <div class="header_wrap">
        <div class="w_1200">
          <div class="h_right">
            <a href="http://www.xyzwfw.gov.cn/zwdt/epointzwmhwz/pages/default/index">信阳市政务服务网</a>
            <a href="https://www.xinyang.gov.cn/">信阳市政府门户网站</a>
            <template v-if="!userInfo">
              <a @click="toLogin2">省登录</a>
              <a @click="toLogin">本地登录</a>
              <a @click="toRegister">注册</a>
            </template>
            <template v-else>
              <a @click="toWork">{{ showUserName }}</a>
              <a @click="gotoItem('/logout')">退出</a>
            </template>
          </div>
          <div class="h_nav">
            <a :class="titleType == 1 ? 'active' : ''" @click="check(1)">首页</a>
            <a :class="titleType == 11 ? 'active' : ''" @click="check(11)">免申即享</a>
            <a :class="titleType == 2 ? 'active' : ''" @click="check(2)">精准推送</a>
            <a :class="titleType == 4 ? 'active' : ''" @click="check(4)">政策申报</a>
            <a :class="titleType == 10 ? 'active' : ''" @click="check(10)">政策库</a>
            <a :class="titleType == 12 ? 'active' : ''" @click="check(12)">数据统计</a>
            <a :class="titleType == 6 ? 'active' : ''" @click="check(6)">企业诉求</a>
          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { LOGIN_URL, LOGIN_URL_BACK } from "@/store/mutation-types";

export default {
  name: "Header",
  components: {

  },
  data() {
    return {
      showUserName: "",
      loginList: [
        {
          name: "工作台",
          icon: "el-icon-user",
          path: "/workplace/index",
        },
        {
          name: "账户管理",
          icon: "el-icon-setting",
          path: "/workplace/setting",
        },
        {
          name: "退出",
          icon: "el-icon-switch-button",
          path: "/logout",
        },
      ],
      msTitleList: [
        { name: "通知", path: "" },
        { name: "公告", path: "" },
        { name: "订阅", path: "" },
      ],
      msTitleCurrentNav: 0,
      tongzhiList: [], // 通知消息
      tongzhiTotal: 0, // 通知消息总数
      gonggaoList: [], // 公告消息
      gonggaoTotal: 0, // 公告总数
      dingyueList: [], // 订阅消息
      dingyueTotal: 0, // 订阅总数
      titleType: 1,
    };
  },
  computed: {
    ...mapGetters({
      userInfo: "getUserInfo",
    }),
    cpu_messageList() {
      switch (this.msTitleCurrentNav) {
        case 0:
          return this.tongzhiList;
        case 1:
          return this.gonggaoList;
        case 2:
          return this.dingyueList;
        default:
          return [];
      }
    },
  },
  methods: {
    /**
     * @description 导航切换
     */
    check(i) {
      let indexkey = i;
      switch (indexkey) {
        case 1:
          this.$router.push({
            name: "policyLibrary",
            // params: { titleType: this.titleType },
          });
          break;
        case 2:
          if (this.$store.getters.getUserInfo) {
            this.$router.push("/policyResult");
          } else {
            this.$router.push("/policy");
          }
          break;
        case 3:
          //判断是否登录
          if (this.$store.getters.getUserInfo) {
            this.$router.push({
              name: "policyMatchReport",
              // params: { titleType: this.titleType },
            });
          } else {
            //未登录
            this.toLogin("policyMatchReport");
          }

          break;
        case 4:
          this.$router.push({
            name: "policyProgram",
            // params: { titleType: this.titleType },
          });
          break;
        case 5:
          this.$router.push({
            name: "policyAnalysis",
            // params: { titleType: this.titleType },
          });
          break;
        case 6:
          this.$router.push({
            name: "qysq",
            // params: { titleType: this.titleType },
          });
          break;
        case 9:
          this.$router.push({
            name: "enterpriseLibrary",
            // params: { titleType: this.titleType },
          });
          break;
        case 10:
          this.$router.push({
            name: "showPolicy",
            // params: { titleType: this.titleType },
            query: { linkType: true },
          });
          break;
        case 11:
          this.$router.push({
            name: "viewEnjoyPage",
          });
          break;
        case 12:
          this.$router.push({
            name: "statistics",
          });
          this.titleType = 12;
          break;
        default:
          break;
      }
    },
    /**
     * @description: 前往尝鲜版本
     */
    toEarly() {
      const { href } = this.$router.resolve({
        path: "/home_early",
      });
      window.open(href, "_blank");
    },
    /**
     * @description: 显示二维码弹窗
     */
    // showQrPopup() {
    //   // console.log('showQrPopup')
    //   this.$refs["loginQrcode"].startPolling();
    // },
    /**
     * @description: 隐藏二维码弹窗
     */
    hideQrPopup() {
      // console.log('hideQrPopup')
      this.$refs["loginQrcode"].stopPolling();
    },
    /**
     * @description: 前往首页
     */
    toHome() {
      sessionStorage.setItem("titleType", 1, 5 * 60 * 1000);
      // this.$router.push({ name: "policyLibrary", params: { titleType: 1 } });
      this.$router.push({ name: "policyLibrary" });
    },
    /**
     * @description: 前往登录
     */
    toLogin(backurl) {
      // var pathname = window.location.host;
      // if (backurl) {
      //   var url =
      //     LOGIN_URL +
      //     "?refer=cp&backUrl=" +
      //     LOGIN_URL_BACK +
      //     "?targetUrl=" +
      //     pathname +
      //     "/policyMatchReport";
      // } else {
      //   var url =
      //     LOGIN_URL +
      //     "?refer=cp&backUrl=" +
      //     LOGIN_URL_BACK +
      //     "?targetUrl=" +
      //     pathname;
      // }
      // window.location.href = url;
      this.$router.push({ path: "/login2" });
    },

    toLogin2(backurl) {
      var pathname = window.location.host;
      if (backurl) {
        var url =
          LOGIN_URL +
          "?refer=cp&backUrl=" +
          LOGIN_URL_BACK +
          "?targetUrl=" +
          pathname +
          "/policyMatchReport";
      } else {
        var url =
          LOGIN_URL +
          "?refer=cp&backUrl=" +
          LOGIN_URL_BACK +
          "?targetUrl=" +
          pathname;
      }
      window.location.href = url;
    },

    /**
     * @description: 前往注册
     */
    toRegister() {
      this.$router.push({
        path: "/register2",
      });
      // let href = "https://login.hnzwfw.gov.cn/tacs-uc/corp/register";
      // window.open(href, "_blank");
    },
    /**
     * @description: 前往工作台
     */
    toWork() {
      this.$router.push({ path: "/workplace/index" });
    },
    gotoItem(el) {
      // console.log("el:", el);
      if (el == "/logout") {
        this.$confirm("是否退出登录？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(() => {
            this.$store.dispatch("logout", {}).then(() => {
              this.$message.success("登出成功");
              this.$router.push("/home");
            });
          })
          .catch(() => {});
      } else {
        this.$router.push({ path: el });
      }
    },
    getLength(index) {
      if (index === 0) {
        return this.tongzhiTotal;
      } else if (index === 1) {
        return this.gonggaoTotal;
      } else {
        return this.dingyueTotal;
      }
    },
    /* 改变通知栏 */
    changemsNav(index) {
      this.msTitleCurrentNav = index;

      // let path = this.msTitleList[index].path;
      // this.$router.replace({ path: path });
    },
    // 前往我的信息中心
    gotoMyMessage() {
      this.$router.push({ path: "/workplace/message" });
    },
    /**
     * @description: 查询消息
     * @param {*} type 消息类型
     * @return {Promise}
     */
    getMessageData(type) {
      return new Promise((resolve, reject) => {
        let url = "/dev-api/message/list";
        let params = {
          type,
          pageNum: 1,
          pageSize: 3,
        };
        this.$httpApi
          .get(url, params)
          .then((res) => {
            // console.log('getMessageData:', res)
            resolve(res);
          })
          .catch((err) => {
            console.log("getMessageData error:".err);
            reject(err);
          });
      });
    },
    // 监听返回按钮的处理函数
    // onCloseModal() {
    //   // 获取当前页面的url地址
    //   sessionStorage.setItem(
    //     "titleType",
    //     sessionStorage.getItem("titleTypeBack")
    //   );
    //   this.$router.go(0);
    // },
  },
  created() {
    if (!sessionStorage.getItem("titleType")) {
      sessionStorage.setItem("titleType", this.titleType);
    }
    if (this.userInfo && this.userInfo.enterpriseList) {
      if (this.userInfo.enterpriseList.length > 0) {
        this.showUserName = this.userInfo.enterpriseList[0].enterprise;
      } else {
        this.showUserName = this.userInfo.nickName;
      }
    }
  },
  // destroyed() {
  //   window.removeEventListener("popstate", this.onCloseModal, false);
  // },
  mounted() {
    // 监听浏览器的返回按钮
    // if (window.history && window.history.pushState) {
    //   history.pushState(null, null, document.URL);
    //   window.addEventListener("popstate", this.onCloseModal, false);
    // }

    let titleType = sessionStorage.getItem("titleType");
    if (titleType) {
      this.titleType = Number(titleType);
    }
    if (window.location.href.indexOf("policyMatchReport") > -1) {
      this.titleType = "3";
    } else {
    }
    this.getMessageData(1).then((res) => {
      if (res.code == 200) {
        this.tongzhiList = res.rows || [];
        this.tongzhiTotal = res.total || 0;
      }
    });
    this.getMessageData(2).then((res) => {
      if (res.code == 200) {
        this.gonggaoList = res.rows || [];
        this.gonggaoTotal = res.total || 0;
      }
    });
    this.getMessageData(3).then((res) => {
      if (res.code == 200) {
        this.dingyueList = res.rows || [];
        this.dingyueTotal = res.total || 0;
      }
    });
  },
  watch: {
    userInfo(newVal) {
      console.log("userInfo:", newVal);
    },
    $route(to, from, next) {
      this.titleType = sessionStorage.getItem("titleType");
      // if (this.$route.params.titleType) {
      //   this.titleType = this.$route.params.titleType;
      // } else if (sessionStorage.getItem("titleType")) {
      //   this.titleType = sessionStorage.getItem("titleType");
      // }
      // switch (from.fullPath) {
      //   case "/showPolicyDetail":
      //     if(to.fullPath == "/showPolicy"){
      //       this.titleType = 10;
      //     }
      //     if(to.fullPath == "/policyLibrary"){
      //       this.titleType = 1;
      //     }
      //     break;
      //   case "/oneThingGuide":
      //      if(to.fullPath == "/enterpriseLibrary"){
      //       this.titleType = 9;
      //     }
      //     if(to.fullPath == "/policyLibrary"){
      //       this.titleType = 1;
      //     }
      //     break;
      //   default:
      //     break;
      // }
    },
  },
};
</script>

<style lang="scss" scoped>
  @import "@/assets/newStyle/css/idx.scss";
  @import "@/assets/newStyle/css/login.scss";

</style>
